import { useSearchParams } from 'react-router'

import { AuthToastMessage } from '@/components/AuthToastMessage'
import { FeedbackModal } from '@/components/FeedbackModal/FeedbackModal'
import { Loading } from '@/components/Loading'
import { LoginForm } from '@/components/login-form'
import { Button } from '@/components/ui/button'
import { useDisclosure } from '@/hooks/use-disclosure'
import { AuthFooter, AuthLayout } from '@/layouts/AuthLayout'
import { useAuth } from '@/lib/auth'

export default function LoginPage() {
  const [searchParams] = useSearchParams()
  const ref = searchParams.get('ref')
  const email = searchParams.get('email')

  const { isOpen: isFeedbackOpen, onToggle } = useDisclosure()

  const { isLoading } = useAuth({
    middleware: 'guest',
    tmp: 'SignIn',
  })

  if (isLoading) {
    return (
      <div className="flex min-h-svh items-center justify-center">
        <Loading />
      </div>
    )
  }

  const handleSuccess = () => {
  }

  return (
    <AuthLayout>
      <title>Přihlášení</title>

      <AuthToastMessage ref={ref} />

      <LoginForm email={email} onSuccess={handleSuccess} />

      <AuthFooter>
        <Button variant='link' size='sm' onClick={onToggle}>Zpětná vazba</Button>
        <FeedbackModal isOpen={isFeedbackOpen} onToggle={onToggle} />
      </AuthFooter>
    </AuthLayout>
  )
}
